import React from "react";
import backicon from "./../image/backicon.svg";
import logo from "../../newProviderApp/image/playbacklogo.png";
const BackButton = ({ onClick, className, isSignup = false }) => {
   return (
      <img
         onClick={isSignup ? undefined : onClick}
         src={isSignup ? logo : backicon}
         height={isSignup ? 60 : ""}
         width={isSignup ? 159 : ""}
         alt="backicon"
         className={className}
      />
   );
};

export default BackButton;
